import { render, staticRenderFns } from "./ProfilingSettings.vue?vue&type=template&id=36d2c156"
import script from "./ProfilingSettings.vue?vue&type=script&lang=js"
export * from "./ProfilingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports